"use client";

import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { EmptyLibraryState } from "@/features/library/components/empty-library-state";
import { useGetStudySets } from "@/features/studysets/api/use-get-studysets";
import {
  StudySetCard,
  StudySetCardsSkeleton,
} from "@/features/studysets/components/studyset-card";
import { StudySetLoadingError } from "@/features/studysets/components/studyset-loading-error";

export const RecentStudySets = () => {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={({ resetErrorBoundary }) => (
            <StudySetLoadingError resetErrorBoundary={resetErrorBoundary} />
          )}
        >
          <Suspense fallback={<StudySetCardsSkeleton cols={3} count={3} />}>
            <RecentStudySetsContent />
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
};

const RecentStudySetsContent = () => {
  const { data: studySets } = useGetStudySets();

  const recentSets = studySets?.slice(0, 3);

  // Empty state
  if (!recentSets?.length) {
    return <EmptyLibraryState isAuthenticated={true} />;
  }

  // Success state
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {recentSets.map((set) => (
        <StudySetCard key={set.id} studySet={set} isPublic={false} />
      ))}
    </div>
  );
};
